import Swiper from 'swiper/bundle';
import bus from '../util/eventBus';
import deepAssign from '../util/merge';

const swipers = () => {
  const sliders = document.querySelectorAll('[data-swiper-slider]');

  if (sliders.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < sliders.length; i++) {
      const captionSlider = sliders[i].querySelector(
        '.swiper-container--captions',
      );

      let captionSwiper = false;

      if (captionSlider) {
        const captionDefaults = {
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoHeight: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        };

        const captionOptions = captionSlider.getAttribute(
          'data-swiper-caption-options',
        )
          ? JSON.parse(
              captionSlider.getAttribute('data-swiper-caption-options'),
            )
          : {};

        const captionSettings = deepAssign(captionDefaults, captionOptions);
        captionSwiper = new Swiper(captionSlider, captionSettings);
      }

      const slider = sliders[i].querySelector('.swiper-container--main');
      if (slider) {
        const defaults = {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.c-slider--next',
            prevEl: '.c-slider--prev',
          },
        };

        const options = slider.getAttribute('data-swiper-options')
          ? JSON.parse(slider.getAttribute('data-swiper-options'))
          : {};

        const settings = deepAssign(defaults, options);
        const swiper = new Swiper(slider, settings);

        if (captionSwiper) {
          swiper.controller.control = captionSwiper;
        }

        // # trigger lozad redraw
        swiper.on('slideChange', () => {
          bus.emit('feag-slide-change', true);
        });
      }
    }
  }
};

swipers();
